import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    ASSIGNEE, CHANGE_ASSGINEE, ASSGINEE_ACCOUNT, DEALER_LISTING_ASSIGNEE, REASSIGN_DEALER_MANAGER
} from "./type";


export const fetchAssignee = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.fetchReportee}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ASSIGNEE,
            payload: data.response.data,
        });
        return true;
    }
};

export const changeAssignee = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.changeAssignee}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: CHANGE_ASSGINEE,
            payload: data.response,
        });
        return true;
    }
};

export const assgineeAccount = (data=[{}], search = '') => async (dispatch) => {
    let urls = `${Config.assigneeAccount}`

    if(search !== ''){
        urls = `${Config.assigneeAccount}?search=${search}`
    }
    Object.keys(data[0]).map((val, i)=>{
        if(i === 0 && search === ''){
            urls+="?"+val+"="+data[0][val]
        }else{
            urls+="&"+val+"="+data[0][val]
        }
    })
    const res = await callWebService(
        callTypes.get,
        '',
        urls
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ASSGINEE_ACCOUNT,
            payload: data.response,
        });
        return true;
    }
};

export const fetchDealerListing = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.dealerListingForAssignee}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: DEALER_LISTING_ASSIGNEE,
            payload: data.response.data,
        });
        return true;
    }
};

export const dealerManagerReassign = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.reassignDealerManager}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: REASSIGN_DEALER_MANAGER,
            payload: data.response,
        });
        return true;
    }
};




